<template>
  <div class="content">
    <div class="row">
      <div class="col-md-8">
        <edit-profile-form :model="model"> </edit-profile-form>
      </div>
      <div class="col-md-4">
        <user-card :user="user"></user-card>
      </div>
    </div>
  </div>
</template>

<script>
import EditProfileForm from "./Profile/EditProfileForm.vue";
import UserCard from "./Profile/UserCard.vue";
export default {
  components: {
    EditProfileForm,
    UserCard,
  },
  data() {
    return {
      model: {
        company:"",
        email:"",
        name: "",
        userId:"",
		loginName:"",
        address:"",
        city:"",
        country:"",
		mobile:"",
      },
      user: {
        fullName:"",
        title: "",
		company: "",
		mobile:"",
        description: ``,
		userId:"",
      },
	  test:{
		id:"",  
	  },
	  msg:"",
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
	async getUserDetail(){
		let res =await this.$axios.get(this.$serverUrl+"/user/details");
		this.model.mobile=res.data.data.mobile;
		this.model.company=res.data.data.company;
		this.model.loginName=res.data.data.loginName;
		this.model.name=res.data.data.name;
		this.model.email=res.data.data.email;
		this.model.userId=res.data.data.userId;
		this.model.address=res.data.data.address;
		this.model.city=res.data.data.city;
		this.model.country=res.data.data.country;
		this.model.mobile=res.data.data.mobile;
	},
  }
};
</script>
<style></style>
